
(function(){
 const root=document.querySelector('[data-airaa-v28-product]'); if(!root)return;
 const sticky=document.querySelector('[data-airaa-v28-sticky]');
 const buy=document.querySelector('[data-airaa-v28-buy]');
 const add=root.querySelector('form[action*="/cart/add"]');
 const modal=document.querySelector('[data-airaa-v28-size-modal]');
 const open=document.querySelector('[data-airaa-v28-size-open]');
 const close=document.querySelector('[data-airaa-v28-size-close]');
 const variant=root.querySelector('[name="id"]');
 function sync(){if(variant&&buy)buy.dataset.variant=variant.value}
 if(variant){variant.addEventListener('change',sync);sync()}
 window.addEventListener('scroll',()=>{if(!sticky)return;sticky.classList.toggle('is-visible',window.scrollY>420)}, {passive:true});
 if(buy)buy.addEventListener('click',async()=>{
   if(!buy.dataset.variant)return;
   buy.disabled=true; buy.textContent='Adding...';
   try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(buy.dataset.variant),quantity:1}]})});buy.textContent='Added ✓';setTimeout(()=>location.href='/cart',500)}
   catch(e){buy.textContent='Try Again';setTimeout(()=>{buy.disabled=false;buy.textContent='Add to Bag'},1300)}
 });
 if(open&&modal)open.addEventListener('click',()=>modal.classList.add('is-open'));
 if(close&&modal)close.addEventListener('click',()=>modal.classList.remove('is-open'));
 if(modal)modal.addEventListener('click',e=>{if(e.target===modal)modal.classList.remove('is-open')});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal)modal.classList.remove('is-open')});
 const df=document.querySelector('[data-airaa-delivery-form]');
 if(df)df.addEventListener('submit',e=>{e.preventDefault();const pin=df.querySelector('input').value.trim();const out=df.querySelector('p');out.textContent=/^[1-9][0-9]{5}$/.test(pin)?'Delivery availability will be confirmed at checkout.':'Please enter a valid 6-digit PIN code.'});
})();
